import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';
import supportAnimation from '../assets/Anim/Anim.json'; // Your Lottie JSON
import bot from '../assets/customer-service.png'; // Your bot animation JSON
import whatsapp from '../assets/whatsapp.png'; // Your WhatsApp icon
import call from "../assets/telephone-call.png"

export default function FloatingSupportMenu() {
const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
    {
      isMobile ?
      <></>
      :
      <>
      <div
      style={{
        position: "fixed",
        bottom: 0,
        right:isMobile?10: 50,
        width: 90,
        zIndex: 1000,
      }}
    >
      {/* Option Buttons */}
      {open && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20, marginBottom: isMobile ? 50 : 40 }}>
          {/* Chatbot Button */}
          <button
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 0 8px rgba(0,0,0,0.15)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 500,
                border: "none",
            }}
            onClick={() => alert("Open Chatbot")}
          >
        <img src={call} alt="Chatbot" style={{ width: 30, height: 30 }} />
          </button>

            <button
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 0 8px rgba(0,0,0,0.15)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 500,
                border: "none",
            }}
            onClick={() => alert("Open Chatbot")}
          >
        <img src={bot} alt="Chatbot" style={{ width: 30, height: 30 }} />
          </button>


          {/* WhatsApp Button */}
          <button
            style={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 0 8px rgba(0,0,0,0.15)",
              color: "#fff",
              fontSize: 20,
              border: "none",
            }}
            onClick={() => window.open("https://wa.me/1234567890", "_blank")}
          >
             <img src={whatsapp} alt="Chatbot" style={{ width: 30, height: 30 }} />
          </button>
        </div>
      )}

      {/* Main Support Button */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 100,
          background: "#fff",
          marginBottom: isMobile ? 80 : 60,
          width: 90,
          height: 90,
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        <Lottie animationData={supportAnimation} loop={true} style={{ width: 80, height: 80 }} />
        {/* <div
          style={{
            position: "absolute",
            bottom: 10,
            color: "#07448E",
            fontSize: 12,
            fontWeight: "500",
            marginBottom: 30,
          }}
        >
          Support
        </div> */}
      </div>
    </div>
      </>
    }
    
    </>
  );
};